import AbstractModule from './AbstractModule';
import {$window, $document, $body, APP_NAME} from '../utils/environment';
import {EVENT as BOOKING_CART_EVENT} from './BookingCart';
import {EVENT as CONTACT_TOGGLE_EVENT} from './ContactToggle';
import {Event as SCROLL_EVENT} from './LocomotiveScroll';
import {EVENT as TRANSITION_EVENT} from '../transitions/TransitionManager';
import {EVENT as PAYMENT_FORM_EVENT} from './PaymentForm';
import {EVENT as PAYMENT_POPUP_EVENT} from './PaymentPopup'

const MODULE_NAME = 'CartForm';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    PASSENGER_UPDATE: `passengerUpdate.${EVENT_NAMESPACE}`,
    FOCUSOUT: `focusout.${EVENT_NAMESPACE}`,
    BOOKING_PREPARED: `bookingPrepared.${EVENT_NAMESPACE}`,
    PAYMENT_DONE: `paymentDone.${EVENT_NAMESPACE}`,
};

const SELECTOR = {
    point: '.js-departure-point',
    passenger: '.js-passenger',
    passengerName: '.js-passenger-name'
};

export default class extends AbstractModule {

    /**
     * Constructor.
     *
     * @return {void}
     */
    constructor(options) {
        super(options);

        this.$departurePoints = this.$el.find(SELECTOR.point);
        this.$passengers = this.$el.find(SELECTOR.passenger);
        this.$passengersName = this.$el.find(SELECTOR.passengerName);
        this.$globalErrorMsg = this.$el.find('.js-global-error-msg');

        // stripe
        // Private vars.
        this._price; // Total including taxes if any.

        // Regular vars
        this.apiKey = options.key;
        this.paymentAction = options.paymentUrl || 'payment';
        this.stripeInstance;
        this.bookingId;
        this.isProcessingStripe = false;
    }

    /**
     * Initialize dom and events.
     *
     * @return {void}
     */
    init() {
        this.events();
    }

    updateCart(options) {
        let departure = options.departure;
        let numPassengers = options.numPassengers;
        let totalPrice = options.totalPrice;
        let code = options.code;
        let tour = options.tour;

        let dps = departure.departurePoints;

        this.updateNumPassenger(numPassengers);

        this.$el.find('input[name=departure]').val(departure.id);
        this.$el.find('input[name=payment]').val(totalPrice);
        this.$el.find('input[name=numPassengers]').val(numPassengers);
        this.$el.find('input[name=code]').val(code);

        this.setPrice(parseFloat(totalPrice) * 100);


        // console.log(departure);
        // Should match the exact type instead of not undefined
        if (typeof window.gtag !== 'undefined') {
            gtag("event", "add_to_cart", {
                currency: "GBP",
                value:    parseFloat(totalPrice) * 100,
                items:    [
                    {
                        item_id:   tour.id,
                        item_name: tour.name,
                        price:     departure.price,
                        quantity:  numPassengers
                    }
                ]
            });
        }

        if (typeof window.dataLayer !== 'undefined') {
            dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    currency: "GBP",
                    value:    parseFloat(totalPrice) * 100,
                    items:    [
                        {
                            item_id:   tour.id,
                            item_name: tour.name,
                            price:     departure.price,
                            quantity:  numPassengers
                        }
                    ]
                }
            });
        }

        // disable departure points and enable by departure.
        this.$departurePoints.addClass('-disabled');

        for (let dp in dps) {
            this.$el.find(SELECTOR.point + '[data-point=' + dps[dp] + ']').removeClass('-disabled');
        }

        this.$departurePoints.each((ident, ele) => {
            $(ele).hasClass('-disabled')
                ? $(ele).find('input').attr('disabled', true).prop('checked', false)
                : $(ele).find('input').attr('disabled', false);
        });
    }

    updateNumPassenger(numPassenger) {
        this.$passengers.each((index, ele) => {
                if (numPassenger > index) {
                    $(ele).slideDown(() => this.updateScroll()).find('input,select').attr('disabled', false);
                    $document.triggerHandler({
                        type: CONTACT_TOGGLE_EVENT.UPDATE,
                        scope: $(ele)
                    });
                } else {
                    $(ele).slideUp(() => this.updateScroll()).find('input,select').attr('disabled', true);
                }
            }
        );
    }

    updateScroll() {
        $('.js-scroll').triggerHandler(SCROLL_EVENT.UPDATE);
    }

    applyPayment(stripeId) {
        this.toggleProcessingStripe(true);

        // Legacy
        if (window.ga) {
            // specify a checkout step and option.
            ga('ec:setAction', 'checkout', {
                step: 3,
                option: stripeId
            });

            ga('send', 'event', 'Checkout', 'Option');

        }

        // New GA4 tag should work this way
        if (window.gtag) {
            window.gtag('event', 'checkout_progress', {
                name: 'Checkout - Option',
                step: 3,
                option: stripeId
            });
        }

        // GTM
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'checkout_progress',
                ecommerce: {
                    name:   'Checkout - Option',
                    step:   3,
                    option: stripeId
                }
            });
        }

        $.post('finalize/booking', {
            bookingId: this.bookingId,
            stripeId: stripeId
        }, (response) => {
            this.toggleProcessingStripe(false);
            if (response.success) {
                this.addEcommerceTracking(response.ecommerce);

                $document.triggerHandler({
                    type: TRANSITION_EVENT.GOTO,
                    options: {
                        transition: 'default',
                        location: response.next_url
                    }
                });
            } else {

            }
        }, 'json');
    }

    events() {
        $document.on(EVENT.BOOKING_PREPARED, (options) => this.checkout(options));
        $document.on(EVENT.PAYMENT_DONE, (options) => this.onPaymentDone(options));
        this.$passengersName.on(EVENT.FOCUSOUT, (options) => {
            let passenger = $(options.currentTarget);

            $document.triggerHandler({
                type: EVENT.PASSENGER_UPDATE,
                ident: passenger.data('ident'),
                value: passenger.val(),
            });
        });

        // external listeners
        $document.on(BOOKING_CART_EVENT.UPDATE_CART, (options) => this.updateCart(options));
    }

    onPaymentDone(options) {
        const { response } = options

        $document.triggerHandler({
            type: PAYMENT_POPUP_EVENT.TOGGLE,
            flag: false
        })

        if (response.success) {
            this.paymentSuccessfull(response);
        } else {
            this.paymentFailure(response);
        }
    }

    /**
     * Simple method for toggling animation states
     *
     * @return void
     */
    toggleProcessingStripe(state) {
        this.isProcessingStripe = state;
        $body.toggleClass('is-stripe-processing', this.isProcessingStripe);
    }

    /**
     * Destructor.
     *
     * @return {void}
     */
    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
        $document.off(`.${EVENT_NAMESPACE}`);
    }

    // ==========================================================================
    // STRIPE MODULE
    // ==========================================================================

    /**
     * Setup stripe handle
     *
     * @deprecated
     * @return {thisArg} Chainable.
     */
    initStripe() {
        if (this.stripeInstance) {
            return this;
        }

        this.stripeInstance = Stripe(this.apiKey);

        // The following is probably unused
        return this;
    }

    /**
     * Actual checkout
     * @return {thisArg} Chainable.
     */
    checkout(options) {
        // Booking id
        this.bookingId = options.response.bookingId;

        let price = this.price();
        if (!price || price < 1) {
            this.invalidCheckout('Invalid price');
            return this;
        }

        // if (!this.stripeInstance) {
        //     this.initStripe();
        // }

        // Legacy analytics
        if (window.ga) {
            // specify a checkout step and option.
            ga('ec:setAction', 'checkout', {
                step: 2,
                option: this.bookingId
            });

            ga('send', 'event', 'Checkout', 'Option');
        }

        // New GA4 tag should work this way
        if (window.gtag) {
            window.gtag('event', 'begin_checkout', {
                name: 'Checkout - Option',
                step: 2,
                option: this.bookingId
            });
        }

        // GTM
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'begin_checkout',
                ecommerce: {
                    name: 'Checkout - Option',
                    step: 2,
                    option: this.bookingId
                }
            });
        }

        if (options.response.skip_payment) {
            return this;
        }

        // SEND EVENT TO PAY

        // this.toggleProcessingStripe(true);

        $document.triggerHandler({
            type: PAYMENT_FORM_EVENT.CHARGE_BOOKING,
            options: {
                amount: this.price(),
                bookingId: this.bookingId
            }
        })

        // this.stripeInstance.open({
        //     name:        'The English Bus',
        //     description: 'Tour booking',
        //     currency:    'gbp',
        //     amount:      this.price()
        // });

        return this;
    }

    /**
     * Whenever an invalid checkout occurs
     * @param  {mixed} feedback Feedback / Reason for the fail.
     * @return {thisArg} Chainable
     */
    invalidCheckout(feedback) {
        // this.toggleProcessingStripe(false);
        // Provide feedback here
        this.$el.css({
            'border': '1px solid red'
        });

        return this;
    }

    /**
     * Called when payment is confirmed.
     * @param response Server response.
     * @return {thisArg} Chainable.
     */
    paymentSuccessfull(response) {
        // Provide positive feedback
        this.applyPayment(response.confirmation.id);

        return this;
    }

    /**
     * Called when payment failed.
     * @param response Server response.
     * @return {thisArg} Chainable.
     */
    paymentFailure(response) {
        this.$globalErrorMsg.html(response.error).slideDown();

        $('.js-scroll').triggerHandler({
            type: 'scrollTo.LocomotiveScroll',
            options: {
                targetElem: this.$globalErrorMsg,
                targetOffset: -250
            }
        });

        // Provide negative feedback
        this.toggleProcessingStripe(false);
        return this;
    }

    /**
     * Set price
     * @param {integer} price Price.
     * @return {thisArg} Chainable.
     */
    setPrice(price) {
        this._price = parseInt(price);
        return this;
    }

    /**
     * @return {integer} Total price.
     */
    price() {
        return this._price;
    }

    addEcommerceTracking($ecommerceData) {
        let eData = $ecommerceData;

        if (window.ga) {
            ga('set', 'currencyCode', 'GBP');

            ga('ec:addProduct', {
                id: eData.id,                 // Transaction ID. Required.
                name: eData.item.name,        // Product name. Required.
                sku: eData.item.sku,          // SKU/code.
                price: eData.item.price,      // Unit price.
                quantity: eData.item.quantity // Quantity.
            });

            ga('ec:setAction', 'purchase', {
                id: eData.id,                 // Transaction ID. Required.
                affiliation: 'Tour',          // Affiliation or store name.
                revenue: eData.revenue        // Grand Total.
            });

            ga('send', 'event', 'Ecommerce', 'purchase');
        }

        // New GA4 tag should work this way
        if (window.gtag) {
            window.gtag('event', 'purchase', {
                    transaction_id: eData.id,
                    value:          eData.revenue,
                    currency:       "GBP",
                    items:          [
                        {
                            item_id:     eData.item.sku,
                            item_name:   eData.item.name,
                            affiliation: "Tour",
                            price:       eData.item.price,
                            quantity:    eData.item.quantity
                        }
                    ]
                }
            );
        }

        // For GTM
        if (window.dataLayer) {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event:     "purchase",
                ecommerce: {
                    transaction_id: eData.id,
                    value:          eData.revenue,
                    currency:       "GBP",
                    items:          [
                        {
                            item_id:     eData.item.sku,
                            item_name:   eData.item.name,
                            affiliation: "Tour",
                            price:       eData.item.price,
                            quantity:    eData.item.quantity
                        }
                    ]
                }
            });
        }
    }
}
